import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { apiClient } from "../client";

export interface PasskeyInfo {
  id: string;
  friendlyName: string | null;
  deviceType: string;
  backedUp: boolean;
  transports: string[];
  lastUsedAt: string | null;
  createdAt: string;
}

interface PasskeyListResponse {
  passkeys: PasskeyInfo[];
}

export const passkeyKeys = {
  list: ["passkeys"] as const,
};

export function usePasskeyList(options: { enabled?: boolean } = {}) {
  return useQuery({
    queryKey: passkeyKeys.list,
    queryFn: () => apiClient.get<PasskeyListResponse>("/auth/passkey/list"),
    staleTime: 30_000,
    enabled: options.enabled ?? true,
  });
}

export function useDeletePasskey() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (passkeyId: string) =>
      apiClient.delete(`/auth/passkey/${passkeyId}`),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: passkeyKeys.list });
    },
  });
}

export function useRenamePasskey() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: ({ id, friendlyName }: { id: string; friendlyName: string }) =>
      apiClient.patch(`/auth/passkey/${id}`, { friendlyName }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: passkeyKeys.list });
    },
  });
}
